export function humanizeSpecialty(key: string): string {
  return key
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

export function shortRunId(runId: string | null | undefined): string {
  if (!runId) return "";
  return runId.length > 8 ? runId.slice(0, 8) : runId;
}

export function formatDurationMs(ms: number | null | undefined): string {
  if (ms == null || Number.isNaN(ms)) return "—";
  if (ms < 1000) return `${(ms / 1000).toFixed(1)}s`;
  const s = ms / 1000;
  if (s < 60) return `${s.toFixed(1)}s`;
  const m = Math.floor(s / 60);
  const rem = Math.round(s % 60);
  return `${m}:${String(rem).padStart(2, "0")}`;
}

export function formatClockMs(elapsedMs: number): string {
  const totalSec = Math.floor(elapsedMs / 1000);
  const m = Math.floor(totalSec / 60);
  const s = totalSec % 60;
  if (m > 0) return `${m}:${String(s).padStart(2, "0")}`;
  if (elapsedMs < 1000) return `${(elapsedMs / 1000).toFixed(1)}s`;
  return `${s}s`;
}

export function relativeTime(iso: string | undefined): string {
  if (!iso) return "";
  const then = new Date(iso).getTime();
  if (Number.isNaN(then)) return "";
  const diff = Date.now() - then;
  const min = Math.floor(diff / 60000);
  if (min < 1) return "just now";
  if (min < 60) return `${min} min ago`;
  const hr = Math.floor(min / 60);
  if (hr < 24) return `${hr} hr ago`;
  const day = Math.floor(hr / 24);
  if (day === 1) return "yesterday";
  return `${day} days ago`;
}

export function formatEvidenceLevel(level: string | undefined): string {
  if (!level) return "—";
  const m = level.match(/level\s*([ivx]+)/i) ?? level.match(/^([ivx]+)$/i);
  if (m) return `Level ${m[1].toUpperCase()}`;
  return level.startsWith("Level") ? level : `Level ${level}`;
}

export function displayDash(value: unknown): string {
  if (value == null || value === "" || value === -1) return "—";
  return String(value);
}

const PMC_VALID = /^PMC\d+$/i;

export function paperLink(paper: { pmc_url?: string; pmcid?: string; doi?: string }): string | null {
  const pmcid = paper.pmcid?.trim();
  if (pmcid && PMC_VALID.test(pmcid)) {
    return `https://pmc.ncbi.nlm.nih.gov/articles/${pmcid}/`;
  }
  if (paper.doi) return `https://doi.org/${paper.doi}`;
  return null;
}
